export default {
    status_no: '404',
    name: 'Не найдено',
    message: 'Эта страница не существует',
}
